import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import Catalog from "./sections/Catalog";
import Spotlight from "./sections/Spotlight";
import NewsletterCta from "./sections/NewsletterCta";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <Overview />
      <Catalog />
      <Spotlight />
      <NewsletterCta />
      <Footer />
    </div>;
}